<template>
  <div class="detail-1" v-if="data">
    <div class="top-content">
      <img class="top-image" :src="data.topImage" alt="" />
      <div
        class="top-btn btn-item"
        id="top-btn"
        @click="bindToWx"
        v-clickBuried
        data-click-buried="CLICK_XINBANYYSXQ_JINXIAN"
        :data-click-eventv="'CLICK_XINBANYYSXQ_JINXIAN_' + id"
        >预约咨询</div
      >
    </div>
    <div v-if="caseData && caseData.case && caseData.case.length">
      <div class="title">部分学员蜕变案例</div>
      <CaseSwiper :data="caseData.case" />
    </div>
    <div class="my-story" v-if="caseData && caseData.story">
      <div class="title">我的故事</div>
      <div class="story-text">
        <div class="story-border" v-html="caseData.story"></div>
      </div>
    </div>
    <img class="bottom-image" :src="data.bottomImage" alt="" />
    <div class="text-content" v-if="caseData && caseData.message">
      <img
        class="dot-icon"
        src="https://cdnvue.gymcity.com.cn/betterwe_1.0/vue/26a72a9370839c32cc6d7fb006f3308b.png"
        alt=""
      />
      <img class="coach-image" :src="data.coachImage" alt="" />
      <div class="text-right">
        <div class="text-title">我想对学员说的话</div>
        <div class="text-say" v-html="caseData.message"></div>
      </div>
    </div>
    <div
      class="fixed-btn btn-item"
      v-show="showFixed"
      @click="bindToWx"
      v-clickBuried
      data-click-buried="CLICK_XINBANYYSXQ_JINXIAN"
      :data-click-eventv="'CLICK_XINBANYYSXQ_JINXIAN_' + id"
      >预约咨询</div
    >
  </div>
</template>

<script>
import CaseSwiper from '../case-swiper.vue'
export default {
  components: { CaseSwiper },
  props: {
    data: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      id: 0,
      showFixed: false,
      caseData: null
    }
  },
  created() {
    this.id = this.$route.query.id
    this.extendId = this.data.extendId
    this.getData()
  },
  mounted() {
    this.addScroll()
  },
  beforeDestroy() {
    this.removeScroll()
  },
  methods: {
    addScroll() {
      window.addEventListener('scroll', this.bindScroll)
    },
    removeScroll() {
      window.removeEventListener('scroll', this.bindScroll)
    },
    bindScroll(e) {
      var scroll = document.documentElement.scrollTop || document.body.scrollTop
      //当顶部按钮滚动到消失 + 10px时显示底部按钮
      let btnTop =
        document.getElementById('top-btn').offsetTop +
        document.getElementById('top-btn').offsetHeight +
        10
      if (scroll >= btnTop) {
        this.showFixed = true
      } else {
        this.showFixed = false
      }
    },
    bindToWx() {
      let jumpUrl = this.data.fixedUrl
      if (jumpUrl) {
        this.$betterwe.jumpRoute(jumpUrl)
      }
    },
    async getData() {
      let params = {
        id: this.extendId
      }
      let res = await this.$http
        .getBaseApp('api/v3/expert/dietitianInfo', params)
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          if (res.data?.case) {
            res.data.case.map((item) => {
              let lessWeight =
                item.compare_data.end_weight - item.compare_data.start_weight
              item.compare_data.lessWeight = parseFloat(lessWeight.toFixed(1))
              let lessWaist =
                item.compare_data.end_waist - item.compare_data.start_waist
              item.compare_data.lessWaist = parseFloat(lessWaist.toFixed(1))
            })
          }
          this.caseData = res.data
        } else {
          this.$toast(res.msg)
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.detail-1 {
  padding-bottom: 122px;
  .top-image {
    min-height: 600px;
  }
  .top-image,
  .bottom-image {
    width: 100%;
    margin-bottom: 10px;
  }
  .top-content {
    position: relative;
  }
  .btn-item {
    width: 335px;
    height: 48px;
    background: linear-gradient(324deg, #373a56 0%, #565e7a 100%);
    box-shadow: 0px 2px 4px 0px rgba(0, 0, 0, 0.16);
    border-radius: 25px;
    font-weight: bold;
    font-size: 18px;
    line-height: 48px;
    text-align: center;
    color: #ffffff;
  }
  .top-btn {
    position: absolute;
    left: 50%;
    bottom: 33px;
    transform: translate(-50%, 0%);
  }
  .fixed-btn {
    position: fixed;
    left: 50%;
    bottom: 44px;
    transform: translate(-50%, 0%);
  }
  .title {
    margin-left: 16px;
    position: relative;
    color: rgba(48, 48, 56, 0.7);
    padding-left: 10px;
    font-weight: bold;
    font-size: 16px;
    line-height: 22px;
    margin-bottom: 11px;
  }

  .title::after {
    content: '';
    position: absolute;
    left: 0;
    top: 50%;
    width: 4px;
    height: 20px;
    background-color: rgba(48, 48, 56, 0.3);
    transform: translate(0%, -50%);
  }
  .text-content {
    position: relative;
    width: 343px;
    padding: 0px 12px;
    box-sizing: border-box;
    background: linear-gradient(
      to bottom,
      #effff8 0%,
      #ffffff 50%,
      #ffffff 100%
    );

    border-radius: 6px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    .dot-icon {
      position: absolute;
      width: 20px;
      top: 16px;
      right: 12px;
    }
    .coach-image {
      width: 75px;
      height: 90px;
      object-fit: contain;
      margin-right: 10px;
    }
    .text-right {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;
      padding: 16px 0px;
    }
    .text-title {
      font-family: MiSans, MiSans;
      font-weight: bold;
      font-size: 15px;
      color: #303038;
      line-height: 20px;
      margin-bottom: 6px;
    }
    .text-say {
      font-family: MiSans, MiSans;
      font-size: 12px;
      color: rgba(48, 48, 56, 0.7);
      line-height: 16px;
    }
  }
  .my-story {
    margin-bottom: 30px;
    .story-text {
      margin: 0px 16px;
      background: #ffffff;
      border-radius: 4px;
      padding: 6px;
      .story-border {
        border: 0.5px solid rgba(48, 48, 56, 0.2);
        padding: 15px 15px 6px;
        border-radius: 2px;
        font-family: MiSans, MiSans;
        font-size: 12px;
        color: rgba(48, 48, 56, 0.8);
        line-height: 23px;
      }
    }
  }
}
</style>
